import { GeoZoneType } from '@EcamModel/model';
import { CameraView } from '@EcamModel/model/CameraView';

export const checkUnmappedPreset = (gotoPointId: number, presetName: string, cameraViews: CameraView[]): boolean => {
    let matched: CameraView | undefined = cameraViews.find((v) => v.PresetId === gotoPointId);

    if (!matched) {
        matched = findInGeoZones(cameraViews, (d) => d.PresetId === gotoPointId);
    }

    if (!matched) {
        matched = cameraViews.find((v) => v.CameraViewName === presetName);
    }

    if (!matched) {
        matched = findInGeoZones(cameraViews, (d) => d.CameraViewName === presetName);
    }

    if (matched) {
        return true;
    }

    return false;
};

const findInGeoZones = (
    cameraViews: CameraView[],
    predicate: (detail: CameraView) => boolean
): CameraView | undefined => {
    for (const view of cameraViews) {
        for (const gz of view.GeoZones || []) {
            if (gz.GeoZoneType === GeoZoneType.Overview && gz.CameraViewDetail) {
                const detail = gz.CameraViewDetail;
                if (predicate(detail)) return detail;
            }
        }
    }
    return undefined;
};
